import { useSuspenseQuery } from "@tanstack/react-query"
import { trpc } from "../utils/trpc"

/** All metric configurations. Suspends until loaded. */
export function useMetrics() {
  const { data } = useSuspenseQuery(
    trpc.metrics.getMetricsConfiguration.queryOptions(undefined, {
      select: (res) => res.data,
    })
  )
  return data
}
